// extracted by mini-css-extract-plugin
export default {"box":"tbd_box__fJVX6"};